import { render, staticRenderFns } from "./BottomIcon.vue?vue&type=template&id=7ba2594a&scoped=true"
import script from "./BottomIcon.vue?vue&type=script&lang=js"
export * from "./BottomIcon.vue?vue&type=script&lang=js"
import style0 from "./BottomIcon.vue?vue&type=style&index=0&id=7ba2594a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba2594a",
  null
  
)

export default component.exports